import { render, staticRenderFns } from "./AxisYLabel.vue?vue&type=template&id=6b5ce41c&scoped=true"
import script from "./AxisYLabel.vue?vue&type=script&lang=js"
export * from "./AxisYLabel.vue?vue&type=script&lang=js"
import style0 from "./AxisYLabel.vue?vue&type=style&index=0&id=6b5ce41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5ce41c",
  null
  
)

export default component.exports